import React from "react";
import { Box } from "@mui/material";
import GlobalDropdownField from "../../shared/utils/GlobalDropdownField";

const ClientApprovalFilters = ({
  filters,
  filterOptions,
  onFilterChange,
  handleFilterClose,
}) => {
  return (
    <Box className="flex gap-3 h-8 ">
      <GlobalDropdownField
        variant="compact"
        search="true"
        name="state"
        multiple={true}
        value={filters.state || []}
        placeholder="Filter State"
        onChange={(e) => onFilterChange(e, "state")}
        onClose={() => handleFilterClose?.("state")}
        options={[
          { value: "", label: "All States" },
          ...filterOptions.stateOptions,
        ]}
        renderValueFn={(selected) => {
          if (!selected || selected.length === 0) return "State";

          if (selected.includes("")) return "All States";

          const labels = selected
            .slice(0, 3)
            .map(
              (val) =>
                filterOptions.stateOptions.find((s) => s.value === val)
                  ?.label || val,
            );

          return labels.join(", ") + (selected.length > 3 ? "..." : "");
        }}
        useNewStyles
      />

      <GlobalDropdownField
        variant="compact"
        search="true"
        name="city"
        value={filters.city || []}
        multiple={true}
        placeholder="City"
        options={[
          { value: "", label: "All Cities" },
          ...(filterOptions.cityOptions || []),
        ]}
        onChange={(e) => onFilterChange(e, "city")}
        onClose={() => handleFilterClose("city")}
        renderValueFn={(selected) => {
          if (!selected || selected.length === 0) {
            return (
              <span
                style={{ color: "var(--listdown-color)", fontSize: "0.75rem" }}
              >
                City
              </span>
            );
          }

          // ✅ ALL selected
          if (selected.includes("")) {
            return (
              <span
                style={{ color: "var(--heading-color)", fontSize: "0.75rem" }}
              >
                All Cities
              </span>
            );
          }

          const labels = selected
            .slice(0, 2)
            .map(
              (val) =>
                filterOptions.cityOptions?.find((city) => city.value === val)
                  ?.label || val,
            );

          return (
            <span
              style={{ color: "var(--heading-color)", fontSize: "0.75rem" }}
            >
              {labels.join(", ")}
              {selected.length > 2 ? "..." : ""}
            </span>
          );
        }}
        useNewStyles
      />
      <GlobalDropdownField
        variant="compact"
        search="true"
        name="store"
        value={filters.store || []}
        multiple={true}
        placeholder="Store Name"
        options={[
          { value: "", label: "All Stores" },
          ...(filterOptions.storeOptions || []),
        ]}
        onChange={(e) => onFilterChange(e, "store")}
        onClose={() => handleFilterClose("store")}
        renderValueFn={(selected) => {
          if (!selected || selected.length === 0) {
            return (
              <span
                style={{
                  color: "var(--listdown-color)",
                  fontSize: "0.75rem",
                }}
              >
                Store
              </span>
            );
          }

          // 👉 If ALL selected
          if (selected.includes("")) {
            return (
              <span
                style={{
                  color: "var(--heading-color)",
                  fontSize: "0.75rem",
                }}
              >
                All Stores
              </span>
            );
          }

          // 👉 Get labels
          const labels = selected
            .slice(0, 2) // 👈 only 2 values
            .map(
              (val) =>
                filterOptions.storeOptions.find((s) => s.value === val)
                  ?.label || val,
            );

          return (
            <span
              style={{
                color: "var(--heading-color)",
                fontSize: "0.75rem",
              }}
            >
              {labels.join(", ")}
              {selected.length > 2 ? "..." : ""}
            </span>
          );
        }}
        useNewStyles
      />

      <GlobalDropdownField
        variant="compact"
        search={true}
        name="zone"
        value={filters.zone || []}
        multiple={true}
        placeholder="Zone"
        options={[
          { value: "", label: "All Zones" },
          ...(filterOptions.zoneOptions || []),
        ]}
        onChange={(e) => onFilterChange(e, "zone")}
        onClose={() => handleFilterClose?.("zone")}
        renderValueFn={(selected) => {
          if (!selected || selected.length === 0 || selected.includes("")) {
            return <span style={{ fontSize: "0.75rem" }}>All Zones</span>;
          }

          const labels = selected
            .slice(0, 2)
            .map(
              (value) =>
                filterOptions.zoneOptions?.find((zone) => zone.value === value)
                  ?.label || value,
            );

          return (
            <span style={{ fontSize: "0.75rem" }}>
              {labels.join(", ")}
              {selected.length > 2 ? "..." : ""}
            </span>
          );
        }}
      />

      <GlobalDropdownField
        variant="compact"
        search="true"
        name="productType"
        value={filters.productType || []}
        multiple={true}
        placeholder="Product"
        options={[
          { value: "", label: "All Products" },
          ...filterOptions.productTypeOptions,
        ]}
        onChange={(e) => onFilterChange(e, "productType")}
        onClose={() => handleFilterClose?.("productType")}
        renderValueFn={(selected) => {
          if (!selected || selected.length === 0) {
            return "Product";
          }

          // 👉 If ALL is selected OR all items selected manually
          const isAllSelected =
            selected.includes("") ||
            selected.length === filterOptions.productTypeOptions.length;

          if (isAllSelected) {
            return <span style={{ fontSize: "0.75rem" }}>All Products</span>;
          }

          // 👉 Normal case
          const labels = selected.map(
            (val) =>
              filterOptions.productTypeOptions.find((p) => p.value === val)
                ?.label || val,
          );

          const displayLabels = labels.slice(0, 2);

          return (
            <span style={{ fontSize: "0.75rem" }}>
              {displayLabels.join(", ")}
              {labels.length > 2 && " ..."}
            </span>
          );
        }}
        useNewStyles
      />

      <GlobalDropdownField
        variant="compact"
        search="true"
        name="status"
        value={filters.status || []}
        placeholder="Status"
        multiple={true}
        options={filterOptions.statusOptions}
        onChange={(e) => onFilterChange(e, "status")}
        onClose={() => handleFilterClose("status")}
        renderValueFn={(selected) => {
          if (!selected || selected.length === 0) {
            return (
              <span
                style={{
                  color: "var(--listdown-color)",
                  fontSize: "0.75rem",
                }}
              >
                Status
              </span>
            );
          }

          // 👉 If ALL selected (value = "")
          if (selected.includes("")) {
            return (
              <span
                style={{
                  color: "var(--heading-color)",
                  fontSize: "0.75rem",
                }}
              >
                All Status
              </span>
            );
          }

          // 👉 Map values to labels
          const statusMap = {
            1: "Approved",
            "-1": "Rejected",
            0: "Pending",
            2: "Hold On",
          };

          const labels = selected
            .slice(0, 2) // 👈 show only 2
            .map((val) => statusMap[val] || val);

          return (
            <span
              style={{
                color: "var(--heading-color)",
                fontSize: "0.75rem",
              }}
            >
              {labels.join(", ")}
              {selected.length > 2 ? "..." : ""}
            </span>
          );
        }}
        useNewStyles
      />
    </Box>
  );
};

export default ClientApprovalFilters;
